// © 2026 Orpyx Medical Technologies Inc.

import {FormControlValidators} from "orpyx-web-common";
import {IPrimaryConcernDto} from "doctors-dashboard/http-clients/index";
import {PatientSubmitCareNoteFormProps, PatientSubmitCareNoteFormValues} from "./patient-submit-care-note-form.interface";
import {FormControlValidators as TimeSpanFormControlValidators} from "../../../../../../shared/pipes/to-minutes-and-seconds";
import {primaryConcernsForAction} from "../primary-concern-selector/primary-concerns";
import {suggestedActionsForConcern} from "../suggested-action-selector/suggested-actions";

const PatientSubmitCareNoteForValidators = FormControlValidators.createValidators<PatientSubmitCareNoteFormValues>({
    comment: [
        FormControlValidators.maxLength(30000)
    ],
    timeSpent: [
        TimeSpanFormControlValidators.timespan,
        TimeSpanFormControlValidators.timespanRange(0, 60 * 60 * 6),
    ],
    actionId: [
        FormControlValidators.required,
        FormControlValidators.numeric,
        FormControlValidators.minValue(1),
    ],
    primaryConcernId: [],
    //  Required only while the selected concern offers suggested actions, which depends on the
    //  selected concern and so is checked below.
    suggestedActionId: [],
    overrideTime: [],
}, (form, result) => {
    if (form.overrideTime) {
        const validationResult = FormControlValidators.required(form.timeSpent);

        if (validationResult) {
            result.timeSpent = validationResult;
        }
    }
});


export const PatientSubmitCareNoteForValidator = (values: PatientSubmitCareNoteFormValues, props: PatientSubmitCareNoteFormProps) => {
    const errors = PatientSubmitCareNoteForValidators.validate(values);

    const primaryConcerns: IPrimaryConcernDto[] = primaryConcernsForAction(props.actions, values.actionId);

    //  Only required while the field is on screen, which is whenever the selected action offers
    //  concerns. The API rejects the same combinations.
    if (primaryConcerns.length > 0) {
        const validationResult = FormControlValidators.required(values.primaryConcernId);

        if (validationResult) {
            errors.primaryConcernId = validationResult;
        }
    }

    //  Same rule one level down: required whenever the selected concern offers suggested actions,
    //  which is exactly when the field is on screen. Stricter than the API, which only insists on
    //  one for a provider escalation.
    if (suggestedActionsForConcern(primaryConcerns, values.primaryConcernId).length > 0) {
        const validationResult = FormControlValidators.required(values.suggestedActionId);

        if (validationResult) {
            errors.suggestedActionId = validationResult;
        }
    }

    return errors;
};
